/*
 * @Author: honghong
 * @LastEditors: honghong
 * @Description:消息服务
 * @email: 3300536651@qq.com
 * @Date: 2019-04-16 15:57:43
 * @LastEditTime: 2019-10-16 17:42:39
 */
export class MessageService {
    constructor() {
    }
}
